import request from '@/utils/request'
// 根据用户编号回显网吧信息
export function echonNetbarInfo(data) {
    return request({
        url:'/netbar/api/netbar/v1/select_by_netbar_id',
        method:'post',
        data
    })
}
export function netbarInfo(data) {
    return request({
        url:'/netbar/api/netbar/v1/edit_netbar',
        method:'post',
        data
    })
}